import React from 'react';
import { RestaurantDetails_getRestaurantDetails_operatingStatus } from '../../../../../types/graphql-types-generated.ts';
import { Icon } from '../../../../../patterns/00-atoms/icon/icon.tsx';

export type OperatingStatusProps = {
  operatingStatus: RestaurantDetails_getRestaurantDetails_operatingStatus;
  showIcon?: boolean;
};

export const OperatingStatus: React.FunctionComponent<OperatingStatusProps> = props => {
  const showIcon = props.showIcon ?? true;
  const labelForStatus = (status: string | null) => {
    switch (status) {
      case 'OPEN':
        return 'geöffnet';
      case 'OPENING_SOON':
        return 'öffnet bald';
      case 'CLOSING_SOON':
        return 'schließt bald';
      case 'CLOSED':
        return 'geschlossen';
      case 'CLOSED_FOR_TODAY':
        return 'geschlossen';
      case 'CLOSED_PERMANENTLY':
        return 'dauerhaft geschlossen';
      default:
        return '';
    }
  };

  return (
    <div className="flex items-center">
      {showIcon && <Icon name="opening-hours-small" className="mr-1 block text-base" />}
      <span>{labelForStatus(props.operatingStatus.status)}</span>
    </div>
  );
};
